var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{staticClass:"py-4"},[_c('h2',{staticClass:"mb-4"},[_vm._v("SELECT Help and References")]),_c('div',{domProps:{"innerHTML":_vm._s(_vm.siteText.helpPageText)}}),_c('hr',{staticClass:"my-5"}),_c('footer-data')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }